import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'justonweb-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: false
})
export class TermsOfUseComponent implements OnInit {

  lang$: Observable<string>;
  private scrollY = 0;

  constructor(
    private router: Router,
    private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    this.lang$ = this.translocoService.langChanges$
      .pipe(
        startWith(this.translocoService.getActiveLang()),
        map((lang: string) => lang.toUpperCase())
      );
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    this.scrollY = window.pageYOffset;
  }
  isSticky() {
    return this.scrollY > 144;
  }

  goToHome() {
    this.router.navigate(["/"]);
  }

}